import { renderToString } from 'preact-render-to-string';
import { MwlIcons } from "../components/MwlIcons";
import i18n from '@i18n';

export const initFullscreenButton = (lightbox) => {
  lightbox.on('uiRegister', () => {
    const isFullscreen = () => !!(document.fullscreenElement || document.webkitFullscreenElement);

    const fullscreenIcon = <MwlIcons icon={'fullscreen'} />;
    const shrinkIcon = <MwlIcons icon={'shrink'} />;

    const updateButton = (el) => {
      const inFullscreen = isFullscreen();
      el.innerHTML = inFullscreen ? renderToString(shrinkIcon) : renderToString(fullscreenIcon);
      el.dataset.tooltip = inFullscreen ? i18n.TOOLBAR.EXIT_FULLSCREEN : i18n.TOOLBAR.FULLSCREEN;
      el.setAttribute('aria-label', inFullscreen ? i18n.TOOLBAR.EXIT_FULLSCREEN : i18n.TOOLBAR.FULLSCREEN);
    };

    const toggleFullscreen = async (el) => {
      if (isFullscreen()) {
        // Exit fullscreen
        const exitFS = document.exitFullscreen || document.webkitExitFullscreen;
        if (exitFS) {
          try {
            await exitFS.call(document);
          } catch (e) {
            // Fullscreen exit failed
          }
        }
      } else {
        // Enter fullscreen
        const docEl = document.documentElement;
        const requestFS = docEl.requestFullscreen || docEl.webkitRequestFullscreen;
        if (requestFS) {
          try {
            await requestFS.call(docEl);
          } catch (e) {
            // Fullscreen request failed (e.g., not triggered by user gesture)
          }
        }
      }
      updateButton(el);
    };

    lightbox.pswp.ui.registerElement({
      name: 'fullscreen-button',
      ariaLabel: i18n.TOOLBAR.FULLSCREEN,
      order: 11,
      isButton: true,
      html: renderToString(fullscreenIcon),
      onInit: (el) => {
        el.dataset.tooltip = i18n.TOOLBAR.FULLSCREEN;

        // Listen for fullscreen changes (e.g., user presses Escape)
        const handleFullscreenChange = () => updateButton(el);
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);

        // Clean up listeners when lightbox closes
        lightbox.on('close', () => {
          document.removeEventListener('fullscreenchange', handleFullscreenChange);
          document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
        });
      },
      onClick: (event, el) => {
        toggleFullscreen(el);
      },
    });
  });

  // Exit fullscreen when closing the lightbox
  lightbox.on('close', () => {
    const isFullscreen = !!(document.fullscreenElement || document.webkitFullscreenElement);
    if (isFullscreen) {
      const exitFS = document.exitFullscreen || document.webkitExitFullscreen;
      if (exitFS) {
        exitFS.call(document).catch(() => {});
      }
    }
  });
};
